import {
  Directive,
  Input,
  ElementRef,
  Renderer2,
  HostListener,
} from '@angular/core';

import { Sort } from '../utils/sort';

@Directive({
  selector: '[appSortData]',
})
export class SortDataDirective {
  @Input() appSortData: Array<any>;
  @Input() property: string;
  constructor(private render: Renderer2, private tragetElem: ElementRef) {}

  @HostListener('click')
  sortData(): void {
    const sort = new Sort();
    const elem = this.tragetElem.nativeElement;
    const order = elem.getAttribute('data-order');
    const type = elem.getAttribute('data-type');
    const property = elem.getAttribute('data-name');
    const percent = elem.getAttribute('data-percent');
    let classValue = elem.className;
    if (order == 'desc') {
      this.appSortData.sort(sort.startSort(this.property, order, type,percent));
      elem.setAttribute('data-order', 'asc');
      this.render.setAttribute(
        elem,
        'class',
        (classValue = 'fa fa-sort ml-2 pointer'
          ? 'fa fa-sort ml-2 pointer'
          : '')
      );
    } else {
      this.appSortData.sort(sort.startSort(this.property, order, type,percent));
      elem.setAttribute('data-order', 'desc');
      this.render.setAttribute(
        elem,
        'class',
        (classValue = 'fa fa-sort pointer ml-2'
          ? 'fa fa-sort pointer ml-2'
          : '')
      );
    }
  }
}
